import { Location } from 'history';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { CoverType, QueryParamKeys } from 'scenes/common/types';

import { mapCoverType } from 'scenes/home/actions';
import { CoverTypeQueryParam } from 'scenes/home/flows/quoteDetails/types';

const getCoverTypeQueryParam = (location: Location) => {
  const ctype = new URLSearchParams(location.search).get(QueryParamKeys.ctype);

  return Object.values(CoverTypeQueryParam).find((opt) => opt === ctype);
};

export const useCoverTypeParam = (
  onSetCoverType: (coverType: CoverType) => void
): CoverTypeQueryParam | undefined => {
  const [coverTypeFromUrl] = useState(getCoverTypeQueryParam(useLocation()));

  useEffect(() => {
    if (coverTypeFromUrl) {
      const coverOption = mapCoverType(coverTypeFromUrl);
      if (coverOption) {
        onSetCoverType(coverOption);
      }
    } else {
      onSetCoverType(CoverType.BuildingAndContents);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return coverTypeFromUrl;
};
